export const arrayMean = (array: number[]) => {
  if (array.length === 0) return 0;

  const sum = array.reduce((acc, val) => acc + val, 0);
  return sum / array.length;
};

export const arrayContainsArray = (superset: any[], subset: any[]) => {
  /**
   * Returns TRUE if the first specified array contains all elements
   * from the second one. FALSE otherwise.
   *
   * @param {array} superset
   * @param {array} subset
   *
   * @returns {boolean}
   */

  if (subset.length === 0) {
    return false;
  }

  return subset.every((value) => {
    return superset.indexOf(value) >= 0;
  });
};

export const positionAscending = (A: any, B: any) => {
  if (B.position === null || B.position === undefined) return -1;
  if (A.position === null || A.position === undefined) return 1;
  return A.position - B.position;
};

export default { arrayMean, arrayContainsArray, positionAscending };
